export const categories = [
  {
    slug: 'yangzhi',
    name: '鲍鱼养殖',
    description: '从苗种选育到成鲍收获，全方位展示鲍鱼科学养殖技术与现代化养殖基地实况',
    icon: 'ri-seedling-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20abalone%20aquaculture%20farm%20with%20clean%20seawater%20tanks%20under%20natural%20sunlight%2C%20rows%20of%20breeding%20pools%2C%20professional%20marine%20farming%20facility%2C%20warm%20coastal%20atmosphere%2C%20editorial%20photography%20with%20soft%20natural%20lighting%2C%20crisp%20and%20clean%20aesthetic&width=800&height=600&seq=cat-yangzhi&orientation=landscape',
  },
  {
    slug: 'bulao',
    name: '鲍鱼捕捞',
    description: '跟随专业潜水员深入海底，记录野生鲍鱼捕捞的惊险过程与技巧要领',
    icon: 'ri-anchor-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20diver%20harvesting%20wild%20abalone%20underwater%20in%20clear%20ocean%20water%2C%20dramatic%20underwater%20scene%20with%20sunlight%20streaming%20through%20surface%2C%20rocky%20seabed%20with%20abalone%20shells%2C%20adventure%20and%20nature%20photography%20style%2C%20vibrant%20marine%20colors&width=800&height=600&seq=cat-bulao&orientation=landscape',
  },
  {
    slug: 'jiagong',
    name: '鲍鱼加工',
    description: '从鲜活鲍鱼到干鲍、冻鲍、即食鲍鱼，详解现代化加工工艺与传统制鲍技法',
    icon: 'ri-knife-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20abalone%20processing%20workshop%20with%20stainless%20steel%20equipment%2C%20workers%20in%20white%20uniforms%20processing%20fresh%20abalone%2C%20clean%20industrial%20food%20processing%20facility%2C%20bright%20natural%20lighting%2C%20hygienic%20modern%20workspace%2C%20editorial%20food%20industry%20photography&width=800&height=600&seq=cat-jiagong&orientation=landscape',
  },
  {
    slug: 'pengren',
    name: '鲍鱼烹饪',
    description: '名厨亲授鲍鱼经典菜肴制作，从家常小炒到国宴大菜，让您在家也能做出星级美味',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20abalone%20dish%20plated%20elegantly%20on%20white%20ceramic%20plate%2C%20gourmet%20Chinese%20cuisine%20presentation%2C%20warm%20restaurant%20lighting%2C%20steam%20rising%20from%20freshly%20cooked%20abalone%2C%20luxurious%20dining%20atmosphere%2C%20food%20photography%20with%20soft%20depth%20of%20field&width=800&height=600&seq=cat-pengren&orientation=landscape',
  },
  {
    slug: 'jianbie',
    name: '品种鉴别',
    description: '深入认识全球主要鲍鱼品种，学会通过外观、色泽、纹理辨别鲍鱼品质与产地',
    icon: 'ri-search-eye-line',
    image: 'https://readdy.ai/api/search-image?query=Various%20types%20of%20abalone%20shells%20displayed%20on%20wooden%20surface%2C%20different%20colors%20and%20sizes%20of%20abalone%20species%2C%20natural%20history%20museum%20style%20display%2C%20educational%20and%20scientific%20aesthetic%2C%20soft%20natural%20lighting%20from%20window%2C%20detailed%20macro%20photography%20style&width=800&height=600&seq=cat-jianbie&orientation=landscape',
  },
  {
    slug: 'yingyang',
    name: '营养科普',
    description: '权威解读鲍鱼营养价值与健康功效，科学指导鲍鱼食用方法与适宜人群',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20abalone%20with%20nutritional%20supplements%20and%20herbs%20arranged%20on%20marble%20surface%2C%20healthy%20lifestyle%20concept%2C%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20wellness%20and%20nutrition%20aesthetic%2C%20warm%20earthy%20tones%20with%20green%20accents&width=800&height=600&seq=cat-yingyang&orientation=landscape',
  },
];